export class RendezVousCalendar {
  classe: string = '';
  color: string = '';
  title: string = 'dsqdsqd';
  start: any = new Date().toISOString().replace(/T.*$/, '') + 'T10:00:00';
  end: any = new Date().toISOString().replace(/T.*$/, '') + 'T12:00:00';
  etat: string = '';
  id: string = '-1';
  type_opp: string = '';
  backgroundColor = '#ff7c10';
  textColor = '#000';
  url: string = '';
  id_opp_md5: string = '';
  editable=false;
  startEditable=false;
  durationEditable=false;
}
